import React, {useContext, useState} from 'react'
import {Switch, message, Popconfirm, Modal, Button, Tooltip} from "antd"
import { changeStatus, saveChangeShippingCarrier } from '../../../../services/api/apiSettingShippingCarrier'
import SettingShippingCarrierContext from "../../context/SettingShippingCarrierContext"
import EditShippingCarrier from './EditShippingCarrier'
import moment from 'moment'
import ShippingCarrierHistory from '../ShippingCarrierHistory'

const TableRow = (props) => {
    const {reLoadShippingCarriersEdit} = useContext(SettingShippingCarrierContext)
    const {shippingCarrier} = props
    const [openEdit, _setOpenEdit] = useState(false)
    const [slugForm, _setSlugForm] = useState('')
    const [shippingCarrierForm, _setShippingCarrierForm] = useState('')
    const [originalCarrierForm, _setOriginalCarrierForm] = useState('')
    const [trackingURLForm, _setTrackingURLForm] = useState('')
    const [shippingBoxForm, _setShippingBoxForm] = useState('')
    const [originalCarrierStatusForm, _setOriginalCarrierStatusForm] = useState(false)
    const [labelGenerationStatusForm, _setLabelGenerationStatusForm] = useState(false)
    const [error, _setError] = useState('')
    const [showHisory, setShowHistory] = useState(false)

    const _changeStatusShippingCarrier = async (field) => {
        const {shippingCarrier} = props
        
        try {
            let status = 'activate'
            if(field === 'originalCarrierStatus'){
                if(shippingCarrier.is_active === true){
                    status = 'deactivate'
                }
            }

            if(field === 'labelGenerationStatus'){
                status = 'enable-gen-label'

                if(shippingCarrier.is_generation_label_enabled === true){
                    status = 'disable-gen-label'
                }
            }

            const {success, message: messChange} = await changeStatus(shippingCarrier._id, status)

            if (!success) {
                return message.error(messChange);
            }

            reLoadShippingCarriersEdit()
            message.success('Update status success!');
        } catch (e) {
            message.error(e.message);
        }
    }

    const _handleOpenModalEdit = () => {
        _setOpenEdit(true)
        _setSlugForm(shippingCarrier.slug || '')
        _setShippingCarrierForm(shippingCarrier.name || '')
        _setOriginalCarrierForm(shippingCarrier.original_carrier || '')
        _setTrackingURLForm(shippingCarrier.tracking_url || '')
        _setShippingBoxForm(shippingCarrier.box_name || '')
        _setOriginalCarrierStatusForm(shippingCarrier.is_active)
        _setLabelGenerationStatusForm(shippingCarrier.is_generation_label_enabled)
    }

    const _handleCloseModalEdit = () => {
        _setError('')
        _setOpenEdit(false)
        _setShippingCarrierForm('')
        _setOriginalCarrierForm('')
        _setTrackingURLForm('')
        _setOriginalCarrierStatusForm(false)
        _setLabelGenerationStatusForm(false)
    }

    const _handleChangeInput = (name, value) => {
        if(name === 'shippingCarrier'){
            _setShippingCarrierForm(value)
        }else if(name === 'originalCarrier'){
            _setOriginalCarrierForm(value)
        }else if(name === 'trackingURL'){
            _setTrackingURLForm(value)
        }else if(name === 'box_name'){
            _setShippingBoxForm(value)
        }
    }

    const _handleChangeOriginalCarrierStatus = (value) => {
        _setOriginalCarrierStatusForm(value)
    }

    const _handleChangeLabelGenerationStatus = (value) => {
        _setLabelGenerationStatusForm(value)
    }

    const _handleSaveChange = async () => {
        try {
            const payload = {
                name : shippingCarrierForm ? shippingCarrierForm : '',
                original_carrier: originalCarrierForm ? originalCarrierForm: '',
                is_active: originalCarrierStatusForm,
                is_generation_label_enabled: labelGenerationStatusForm,
                // tracking_url: trackingURLForm ? trackingURLForm : '',
                box_name: shippingBoxForm ? shippingBoxForm : ''
            }

            const {success, message: messChange} = await saveChangeShippingCarrier(shippingCarrier._id, payload)

            if (!success) {
                return _setError(messChange);
            }

            _setOpenEdit(false)
            _setShippingCarrierForm('')
            _setOriginalCarrierForm('')
            _setTrackingURLForm('')
            _setOriginalCarrierStatusForm(false)
            _setLabelGenerationStatusForm(false)
            reLoadShippingCarriersEdit()
            message.success('Update status success!');
        } catch (e) {
            _setError(e.message)
        }
    }

    const _renderTitleConfirm = (field, status) => {
        return (
            <div>
                If you turn {status ? 'OFF' : 'ON'} the { field === 'originalCarrierStatus' ? 'original carrier status' : 'label generation status'}, { field === 'originalCarrierStatus' ? status ? 'the shipping rules of this carrier cannot be detected' : ' the shipping rules of this carrier will be detected again' : status ? 'the labels of this original carrier can not be generated' : 'the labels of this original carrier will be generated again'}.<span style={{display: 'block'}}>Do you want to turn it {status ? 'OFF' : 'ON'}?</span>
            </div>
        )
    }

    const _onCloseHistory = () => {
        setShowHistory(false)
    }
    const _onShowHistory = () => {
        setShowHistory(true)
    }

    const _renderBoxName = (arrayName) => {
        if(arrayName && arrayName.length > 0){
            return arrayName.join(', ')
        }else{
            return ''
        }
    }

    return (
        <tr className="TableRow">
            <td>
                <Tooltip title={`history`} placement="right">
                    <strong className='cursor-pointer' onClick={_onShowHistory}>{shippingCarrier.slug || ''}</strong>
                </Tooltip>
                <Modal
                    visible={showHisory}
                    width={1110}
                    title='Shipping Carrier History'
                    onCancel={_onCloseHistory}
                    className='shippingCarrierHistoryModal'
                    footer={[
                        error && <p key='error' className="text-danger">{error}</p>,
                        <Button className="cancel" key="cancel" onClick={_onCloseHistory} >Đóng</Button>,
                    ]}
                >
                    <ShippingCarrierHistory shippingCarrierid={shippingCarrier._id} visible={showHisory} />
                </Modal>
            </td>
            <td>{shippingCarrier.name || ''}</td>
            <td>{shippingCarrier.original_carrier || ''}</td>
            <td>{shippingCarrier.box_type || ''}</td>
            <td>{shippingCarrier.shipping_box ?
                <span>
                    {shippingCarrier.box_type==='Split box' &&
                        <span className='font-weight-bold'>{shippingCarrier.box_name ? `${shippingCarrier.box_name}, ` : ''}</span>
                    }
                    {_renderBoxName(shippingCarrier.shipping_box)}
                </span> :
                shippingCarrier.box_name}
            </td>
            {/* <td>{shippingCarrier.combination_box || ''}</td> */}
            {/* <td style={{maxWidth: 360}}>{shippingCarrier.tracking_url ? _renderTrackingUrl(shippingCarrier.tracking_url) : ''}</td> */}
            <td>
            <Popconfirm
                title={_renderTitleConfirm('originalCarrierStatus', shippingCarrier.is_active)}
                onConfirm={() => _changeStatusShippingCarrier('originalCarrierStatus')}
                okText="Yes"
                cancelText="No"
            >
                <Switch checked={shippingCarrier.is_active}/>
            </Popconfirm>
                {/* <Switch onChange={() => _changeStatusShippingCarrier('originalCarrierStatus')} checked={shippingCarrier.is_active}/> */}
            </td>
            <td>
                <Popconfirm
                    title={_renderTitleConfirm('labelGenerationStatus', shippingCarrier.is_generation_label_enabled)}
                    onConfirm={() => _changeStatusShippingCarrier('labelGenerationStatus')}
                    okText="Yes"
                    cancelText="No"
                >
                    <Switch checked={shippingCarrier.is_generation_label_enabled}/>
                </Popconfirm>
                {/* <Switch onChange={() => _changeStatusShippingCarrier('labelGenerationStatus')} checked={shippingCarrier.is_generation_label_enabled}/> */}
            </td>
            <td>{!!shippingCarrier.updated_at ? moment(shippingCarrier.updated_at).format('DD/MM/YYYY HH:mm:ss') : !!shippingCarrier.created_at ? moment(shippingCarrier.created_at).format('DD/MM/YYYY HH:mm:ss') : ''}</td>
            <td className="text-center">
                <span className="text-primary" onClick={_handleOpenModalEdit}>
                    {/* <Link className="linkDetail" to={`/shipping-rule/${shippingCarrier._id}`}><EditOutlined/></Link> */}
                    Edit
                </span>
                {/* <span className="text-primary ml-2">
                    <Link className="linkDetail" to={`/shipping-carrier/${shippingCarrier._id}/shipping-box`} style={{color: 'green'}}>Box</Link>
                </span> */}
                <EditShippingCarrier 
                    handleCloseModalEdit={_handleCloseModalEdit}
                    modal={openEdit}
                    slugForm={slugForm}
                    shippingCarrierForm={shippingCarrierForm}
                    originalCarrierForm={originalCarrierForm}
                    trackingURLForm={trackingURLForm}
                    shippingBoxForm={shippingBoxForm}
                    originalCarrierStatusForm={originalCarrierStatusForm}
                    labelGenerationStatusForm={labelGenerationStatusForm}
                    handleChangeInput={_handleChangeInput}
                    handleChangeOriginalCarrierStatus={_handleChangeOriginalCarrierStatus}
                    handleChangeLabelGenerationStatus={_handleChangeLabelGenerationStatus}
                    handleSaveChange={_handleSaveChange}
                    shippingCarrier={shippingCarrier}
                    error={error}
                />
            </td>
        </tr>
    )
}

export default TableRow
